function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  x: "-29.2%",
  y: "-20.8%",
  width: "158.3%",
  height: "158.3%",
  filterUnits: "objectBoundingBox",
  id: "RadioChecked_svg__31_a"
}, React.createElement("feOffset", {
  dy: 0.5,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.129411765 0 0 0 0 0.498039216 0 0 0 0 0.88627451 0 0 0 1 0",
  in: "shadowBlurOuter1"
})), React.createElement("circle", {
  id: "RadioChecked_svg__32_b",
  cx: 8,
  cy: 8,
  r: 3
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  stroke: "#2D91FB",
  strokeWidth: 0.5,
  fill: "#3B99FC",
  cx: 8,
  cy: 8,
  r: 7.75
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#RadioChecked_svg__31_a)",
  xlinkHref: "#RadioChecked_svg__32_b"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#RadioChecked_svg__32_b"
}));

var SvgRadioChecked = function SvgRadioChecked(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default SvgRadioChecked;